import { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGUAGES } from "./translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (k) => k,
  languages: LANGUAGES,
});

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem("omc-lang");
      if (saved && translations[saved]) return saved;
    } catch (_) {}
    return "en";
  });

  useEffect(() => {
    try {
      localStorage.setItem("omc-lang", lang);
      document.documentElement.lang = lang;
    } catch (_) {}
  }, [lang]);

  const t = (key) => {
    const parts = key.split(".");
    let val = translations[lang];
    for (const p of parts) val = val?.[p];
    if (val === undefined || val === null) {
      let fallback = translations.en;
      for (const p of parts) fallback = fallback?.[p];
      return fallback ?? key;
    }
    return val;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
